import { asBoolean, mapStringList, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.content.codes.Code.
 * Jackson writes the flags as `is_qof` / `should_generate`, and codes are posted back inside
 * update bodies, so the keys keep those names.
 *
 * @typedef {object} CodeData
 * @property {string|null} code
 * @property {string[]} terms
 * @property {boolean} is_qof
 * @property {boolean} should_generate
 */

/**
 * @param {object} raw
 * @returns {CodeData}
 */
export function fromCodeData(raw) {
  const source = requireObject(raw, 'Code');
  return {
    code: optionalString(source.code),
    terms: mapStringList(source.terms, 'Code.terms'),
    is_qof: asBoolean(source.is_qof),
    should_generate: asBoolean(source.should_generate),
  };
}
